import photo_man_old from "../images/photo_man_old.jpeg"
import photo_man_young from "../images/photo_man_young.jpeg"
import photo_woman_old from "../images/photo_woman_old.jpeg"
import photo_woman_young from "../images/photo_woman_young.jpeg"
import photo_blank from "../images/photo_blank.png"
import {get_provincies, normalize_name} from "./questions";


function intRange(low, high) {
    return (val) => {
        let v = null;
        try {
            v = parseInt(val);
        } catch {
            return false;
        }
        return (v <= high) && (v >= low)
    }
}

class Profile {
    static fields = [
        {
            id: "firstname",
            label: "Voornaam",
            type: "text",
            placeholder: "Vul hier uw voornaam in...",
            validateFn: (val) => {
                return val.length > 2
            },
            defaultValue: "Sjaak",

        },
        {
            id: "lastname",
            label: "Achternaam",
            type: "text",
            placeholder: "Vul hier uw achternaam in...",
            validateFn: (val) => {
                return val.length > 2
            },
            defaultValue: "van Dam"
        },
        {
            id: "gender",
            label: "Geslacht",
            phase1Label: "Geslacht",
            phase2Label: "Man of vrouw",
            type: "choice",
            choices: ["Vrouw","Man"],
            defaultValue: true,
            validateFn: (val) => {
                return Number.isInteger(val)
            },
            displayFn: (val) => {
                return (val) ? "Man" : "Vrouw"
            },
        },
        {
            id: "place_of_birth",
            label: "Geboorteplaats (gemeente)",
            type: "text",
            placeholder: "Vul hier uw geboorteplaats in ...",
            validateFn: (val) => {
                return get_provincies(normalize_name(val)) !== undefined
            },
            defaultValue: "Eindhoven"
        }, {
            id: "birth_year",
            label: "Geboortejaar",
            type: "number",
            placeholder: "Vul hier uw geboortejaar in...",
            validateFn: intRange(1900, 2022),
            defaultValue: 1970
        },
        {
            id: "birth_month",
            label: "Geboortemaand",
            type: "number",
            placeholder: "Vul hier uw geboortemaand (in cijfers) in...",
            validateFn: intRange(1, 12),
            defaultValue: 1
        },
        {
            id: "birth_day",
            label: "Geboortedag",
            type: "number",
            placeholder: "Vul hier uw geboortedag (in cijfers) in...",
            validateFn: intRange(1, 31),
            defaultValue: 1
        },
        {
            id: "has_partner",
            label: "In een relatie? (ja/nee)",
            phase2Label: "Relatie",
            phase1Label: "Bent u in een relatie?",
            type: "choice",
            choices: ["Nee","Ja"],
            displayFn: (val) => {
                return (val) ? "ja" : "nee"
            },
            defaultValue: true
        },
        {
            id: "place_of_residence",
            label: "Woonplaats (gemeente)",
            type: "text",
            placeholder: "Vul hier uw woonplaats in ...",
            validateFn: (val) => {
                return get_provincies(normalize_name(val)) !== undefined
            },
            defaultValue: "Enschede"
        },
        {
            id: "street_of_residence",
            label: "Adres (straat)",
            type: "text",
            placeholder: "Vul hier de straat in waar u woont...",
            validateFn: (val) => {
                return val.length > 2
            },
            defaultValue: "'s-Gravenhaagse Bos"
        },
        {
            id: "is_student",
            label: "Student?  (ja/nee)",
            phase2Label: "Student",
            phase1Label: "Bent u een student?",
            type: "choice",
            choices: ["Nee","Ja"],
            displayFn: (val) => {
                return (val) ? "ja" : "nee"
            },
            defaultValue: true
        },
        {
            id: "photo",
            label: "photo",
            type: "hidden",
            defaultValue: photo_blank,
            hidden:true
        },

    ]

    static defaultProfile = () => {
        return Object.fromEntries(Profile.fields.map(({id, defaultValue}) => [id, defaultValue]))
    }

    static fromObject = (obj) => {
        let profile = Object.fromEntries(Profile.fields.map(({id}) => [id, obj[id]]))
        profile.id = obj.id
        Object.keys(profile).filter(el => profile[el] === undefined)
        let missing_keys = Object.keys(profile).filter(el => profile[el] === undefined)
        if (missing_keys.length > 0) {
            console.log(`Missing keys ${missing_keys} in profile with id ${profile.id}`)
        }
        return profile
    }

}

let profile_man_young = Profile.fromObject({
        id: 0,
        firstname: "Matthijs",
        lastname: "van Veen",
        birth_year: 1999,
        birth_month: 3,
        birth_day: 8,
        place_of_residence: "Leiden",
        place_of_birth: "Haarlem",
        street_of_residence: "Kerkstraat",
        is_student: true,
        has_partner: true,
        gender: 1,
        photo: photo_blank,
    }
)

let profile_man_old = Profile.fromObject({
        id: 1,
        firstname: "Nico",
        lastname: "Ebbert",
        birth_year: 1965,
        birth_month: 12,
        birth_day: 17,
        place_of_residence: "Lelystad",
        place_of_birth: "Groningen",
        street_of_residence: "Schoolstraat",
        is_student: false,
        has_partner: false,
        gender: 1,
        photo: photo_man_old,
    }
)

let profile_woman_young = Profile.fromObject({
        id: 2,
        firstname: "Monique",
        lastname: "Westhoven",
        birth_year: 1996,
        birth_month: 5,
        birth_day: 8,
        place_of_residence: "Middelburg",
        place_of_birth: "Arnhem",
        street_of_residence: "Molenstraat",
        is_student: true,
        has_partner: false,
        gender: 0,
        photo: photo_woman_young,
    }
)

let profile_woman_old = Profile.fromObject({
        id: 3,
        firstname: "Liesbeth",
        lastname: "Krul",
        birth_year: 1966,
        birth_month: 10,
        birth_day: 14,
        place_of_residence: "Maastricht",
        place_of_birth: "Utrecht",
        street_of_residence: "Dorpsstraat",
        is_student: false,
        has_partner: true,
        gender: 0,
        photo: photo_woman_old,
    }
)

let fakeProfiles = [profile_man_young, profile_man_old, profile_woman_young, profile_woman_old]

export {Profile, fakeProfiles}